import React, { useState } from "react";
import Modal from "react-modal";
import Cross from "@safecv/assets/Images/cross.png";
import axios from "axios";
import API from "@safecv/api";
import Radiobox from "./Radiobox";

const customModalStylesUpload = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    padding: "0",
    width: "560px",
    minHeight: "50%",
    height: "60%",
    maxHeight: "80%",
    // overflow: "Hidden",
    transform: "translate(-50%, -50%)",
  },
};

function PRDownloadModal({ closeModal, modalState }) {
  const [singleExport, setSingleExport] = useState(true);
  const [multipleExport, setMultipleExport] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const [loaderStatus, setLoaderStatus] = useState(false);
  const [exportValue, setExportValue] = useState("");

  function handleCheckBox(val, type) {
    setExportValue("");
    setErrorMessage(null);
    if (type === "single") {
      setSingleExport(val);
      setMultipleExport(false);
    } else if (type === "multiple") {
      setMultipleExport(val);
      setSingleExport(false);
    }
  }

  function exportPR() {
    setLoaderStatus(true);
    axios({
      url: singleExport
        ? API.PDF_DOWNLOADER("plan/" + exportValue + "?download=pr")
        : API.PDF_DOWNLOADER("planpr?plannameprefix=" + exportValue),
      method: "GET",
    })
      .then((response) => {
        setLoaderStatus(false);
        if (response.status === 200) {
          setErrorMessage(null);
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            response.request.getResponseHeader("X-Suggested-Filename")
          );
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          closeModal();
        } else {
          setErrorMessage(response.response.data.message);
        }
      })
      .catch((err) => {
        console.log(err.response);
      });

    //return closeModal();
  }

  return (
    <div>
      <Modal
        isOpen={modalState}
        onRequestClose={closeModal}
        style={customModalStylesUpload}
        ariaHideApp={false}
        contentLabel="Download Modal"
      >
        <div className="row" id="bgcolor">
          <div className="col-sm-10" id="custom-padding">
            <h1 id="fsizeupload">Export PR</h1>
          </div>
          <div className="col-sm-2" id="custom-styling">
            <img
              src={Cross}
              onClick={closeModal}
              alt="quit"
              className="crossStyle"
            />
          </div>
          <div className="upload-files">
            <Radiobox
              singleExport={singleExport}
              onChange={(val) => handleCheckBox(val, "single")}
              label={"Export PR calculation based on job ID"}
              loaderStatus={loaderStatus}
              setExportValue={setExportValue}
              exportValue={exportValue}
            />
          </div>
          <div className="upload-files">
            <Radiobox
              multipleExport={multipleExport}
              onChange={(val) => handleCheckBox(val, "multiple")}
              label={"Export collated PR calculation based on plan name"}
              loaderStatus={loaderStatus}
              setExportValue={setExportValue}
              exportValue={exportValue}
            />
          </div>
          <div className="export-file-modal">
            {errorMessage && (
              <div className="no-option-set">{errorMessage}</div>
            )}
            <label className="cancel-btn-modal" onClick={closeModal}>
              Cancel
            </label>
            <button className="upload-btn1" onClick={() => exportPR()}>
              Export
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );
}

export default PRDownloadModal;